<script setup lang="ts">
import { useCollapse } from "~/composables/tairo/collapse";

const props = withDefaults(
  defineProps<{
    collapse?: boolean
    toolbar?: boolean
    circularMenu?: boolean
    condensed?: boolean
    horizontalScroll?: boolean
  }>(),
  {
    collapse: true,
    toolbar: true,
    circularMenu: true,
  },
)

const route = useRoute();
const app = useAppConfig()
const { isOpen } = useCollapse()

const collapseEnabled = computed(() => {
  return (
    app.tairo.collapse?.navigation?.enabled !== false &&
    props.collapse !== false
  )
})
const toolbarEnabled = computed(() => {
  return (
    app.tairo.collapse?.toolbar?.enabled !== false && props.toolbar !== false
  )
})
const circularMenuEnabled = computed(() => {
  return (
    app.tairo.collapse?.circularMenu?.enabled !== false &&
    props.circularMenu !== false
  )
})

const mainClass = computed(() => {
  if (props.condensed) {
    return 'h-full bg-muted-100 dark:bg-muted-900 relative w-full overflow-x-hidden'
  }

  if (!collapseEnabled.value) {
    return 'h-full bg-muted-100 dark:bg-muted-900 relative w-full overflow-x-hidden px-4 transition-all duration-300 xl:px-10'
  }

  const list = [
    'h-full bg-muted-100 dark:bg-muted-900 relative w-full overflow-x-hidden px-4 transition-all duration-300 xl:px-10',
  ]

  if (isOpen.value) {
    list.push('lg:max-w-[calc(100%_-_420px)] lg:ms-[420px]')
  } else {
    list.push('lg:max-w-[calc(100%_-_80px)] lg:ms-[80px]')
  }

  if (props.horizontalScroll) {
    list.push('!pe-0 xl:!pe-0')
  }

  return list
})
</script>

<template>
  <div class="h-full bg-muted-100 dark:bg-muted-900">
    <slot name="navigation">
      <TairoCollapseLayoutTairoCollapseNavigation v-if="collapseEnabled" />
    </slot>

    <slot name="root"></slot>

    <div :class="mainClass">
      <div
        class="mainContainer flex flex-col h-full pb-4"
      >
        <slot name="toolbar">
          <CollapseToolbar
            :collapse="true"
            :showNavBurger="true"
            class="flex-grow-0 flex-shrink-0"
          >
            <template #title>
              <h1 class="text-4xl text-secondary-500 font-medium">
                {{ route.meta.title }}
              </h1>
            </template>
          </CollapseToolbar>
        </slot>

        <slot />
      </div>
    </div>

    <TairoPanels />

    <TairoCollapseLayoutTairoCollapseCircularMenu v-if="circularMenuEnabled" />
  </div>
</template>

<style scoped>

@media (max-height: 40rem) {
  .mainContainer {
    @apply block;
  }
}

</style>
